module.exports = __webpack_public_path__ + "img/horizontal_3_3_pp3_8003.66af6cea.png";